import * as _React from 'react'
import {
  Root as CollapsibleRoot,
  CollapsibleTrigger,
  CollapsibleContent,
} from '@radix-ui/react-collapsible'

const Collapsible = CollapsibleRoot

export { Collapsible, CollapsibleTrigger, CollapsibleContent }
